
import axios from 'axios'

export default {
    getBatch(){
        return axios.get('/class-batch')
            .then(response => {
                return response.data
            })
    },
    getBatchDataSource(params){
        return axios.get('/class-batch/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getBatchbyID(id){
        return axios.get('/class-batch/' + id)
            .then(response => {
                return response.data
            })
    },    
    createBatch(formdata){
        return axios.post('/class-batch', formdata)
            .then(response => {
                return response.data
            })
    },
    updateBatch(id,formdata){
        return axios.post('/class-batch/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    deactivateBatch(id){
        return axios.put('/class-batch/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateBatch(id){
        return axios.put('/class-batch/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },
    destroyBatch(id){
        return axios.delete('/class-batch/' + id + '/delete')
            .then(response => {
                return response.data
            })
    }, 
    assign_class(id,formdata){
        return axios.post('/class-batch/' + id + '/assign-class-template' ,formdata)
            .then(response => {
                return response.data
            })
    },
    add_class(id,formdata){
        return axios.post('/class-batch/' + id + '/add-class-template' ,formdata)
            .then(response => {
                return response.data
            })
    },
    remove_class(id,batch_id){
        return axios.post('/class-batch/' + batch_id + '/remove-class-template', {
            class_batch_template_id : id
        }).then(response => {
                return response.data
            })
    },
    updateImage(id,formdata){
        return axios.post('/class-batch/' + id + '/image' ,formdata)
            .then(response => {
                return response.data
            })
    },
   
}